import * as t from "io-ts";
import nullable from "./nullable";
import { isoDateTime } from "./date-time";
export const sendContractorInvitationsReqT = t.strict({
    email: t.string,
    clientId: nullable(t.string),
});
export const contractorInvitationT = t.strict({
    id: t.string,
    email: t.string,
    senderEmail: t.string,
    contractorClientId: nullable(t.string),
    createdAt: isoDateTime,
});
const contractorT = t.strict({
    id: t.string,
    name: t.string,
    clientId: nullable(t.string),
    contractorEmail: t.string,
});
export const contractorsT = t.array(contractorT);
export const contractorInvitationsT = t.array(contractorInvitationT);
const subcontractorT = t.strict({
    id: t.string,
    name: t.string,
    subcontractorEmail: t.string,
});
export const subcontractorsT = t.array(subcontractorT);
//# sourceMappingURL=subcontracting-orgs.js.map